import { render, staticRenderFns } from "./SalesAmount.vue?vue&type=template&id=14dd94a3&scoped=true&"
import script from "./SalesAmount.vue?vue&type=script&lang=js&"
export * from "./SalesAmount.vue?vue&type=script&lang=js&"
import style0 from "./SalesAmount.vue?vue&type=style&index=0&id=14dd94a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dd94a3",
  null
  
)

export default component.exports